import React, { useState, useEffect } from 'react';

import {
  Button,
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  Divider,
  Link as MuiLink,
} from '@mui/material';

import { Link } from 'react-router-dom';

import PageContentContainer from 'components/PageContentContainer';
import axios from 'axios';
import ArtistList from 'components/ArtistList';
import SearchBar from 'components/SearchBar/SearchBar';

export default function SearchPage({ match }) {
  const [results, setResults] = useState({});

  const { searchterm } = match.params;

  useEffect(() => {
    const getSearchResults = async () => {
      const { data } = await axios.get(`/api/artists/search/full?searchterm=${searchterm || ''}`);
      setResults(data);
    };
    if (searchterm) {
      getSearchResults();
    }
  }, [searchterm]);

  return (
    <PageContentContainer
      heading="Search"
      breadcrumb="search"
      meta={{
        description: `Search artists on ZIKI.FM. Add them to your favourites and see the latest news, concerts, setlists and merch on Your Music page`,
      }}
    >
      <Box sx={{ my: 5 }}>
        <SearchBar />
      </Box>
      {searchterm && (
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item xs={12} md={9}>
            <Typography component="h2" variant="h3" gutterBottom>
              {searchterm ? `Results for "${searchterm}"` : 'Results'}
            </Typography>
            <Box mb={2}>
              <Typography paragraph gutterBottom>
                Add these artists to your favourites and see the latest news, concerts and merch on
                your page
              </Typography>
              <ArtistList artists={results?.artists} />
            </Box>
            {!!results?.mbArtists?.length && (
              <Box mt={5}>
                <Box pt={2}>
                  <Divider />
                </Box>
                <Typography variant="h5" component="h2" gutterBottom>
                  Artist not listed?
                </Typography>
                <Typography paragraph gutterBottom>
                  Here are the closest matches from the MusicBrainz database. Add to your favourites
                  and we will start gathering all the data for them right away.
                </Typography>
                {results.mbArtists.map((artist) => (
                  <Card key={artist.id}>
                    <CardActionArea component={Link} to={`/artist/${artist.id}`}>
                      <CardContent>
                        <Typography variant="h5" component="h3">
                          {artist.name}
                        </Typography>
                        <Typography color="textSecondary">
                          {artist.country} {artist.disambiguation}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                ))}
              </Box>
            )}
            <Box pt={5}>
              <Divider />
            </Box>
            <Box mt={2}>
              <Typography variant="h5" component="h2" gutterBottom>
                Want to add an artist?
              </Typography>
              <Typography paragraph gutterBottom>
                If you can't find the artist you are looking for, feel free to add or request a new
                artist
              </Typography>
              <Button
                component={Link}
                to={{ pathname: '/add-artist', query: match?.params?.searchterm }}
                variant="outlined"
              >
                Add artist
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography component="h2" variant="h6" gutterBottom>
              Where do we get our artist data from?
            </Typography>
            <Typography paragraph>
              We utilise the great service provided by the{' '}
              <MuiLink href="https://musicbrainz.org/" rel="nofollow">
                MusicBrainz
              </MuiLink>{' '}
              database to gather information about each artist. Once an artist has been added to a
              users favourites, we will start to gather music news and concert information for that
              artist.
            </Typography>
          </Grid>
        </Grid>
      )}
    </PageContentContainer>
  );
}
